import React from 'react';
import { Spinner } from '../../components/ui';
import { INVITE_STATUSES, inviteChipClass, sideChipClass, fullName } from '../../utils/helpers';

// Mobile UI for Mark Status — grouped cards with full-width move buttons.
export default function StatusMobile({ vm }) {
  const { isAdmin, canEdit, mine, rows, loading, grouped, mark } = vm;
  return (
    <div>
      <div className="page-head" style={{ flexWrap: 'wrap' }}><h1>Mark Status</h1><span className="muted">{rows.length}</span></div>
      <div className="muted" style={{ marginBottom: 10, fontSize: 13 }}>
        {isAdmin ? 'All members.' : 'Members you added.'} Tap a status to move a member.
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : rows.length === 0 ? <div className="card card-pad empty">No members yet.</div> : (
          <div style={{ display: 'grid', gap: 14 }}>
            {INVITE_STATUSES.map(status => (
              <div key={status}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 0 6px 2px' }}>
                  <span className={inviteChipClass(status)}>{status}</span>
                  <span className="muted" style={{ fontSize: 13 }}>{grouped[status].length}</span>
                </div>
                {grouped[status].length === 0 ? (
                  <div className="muted" style={{ fontSize: 12, marginLeft: 2 }}>None.</div>
                ) : (
                  <div style={{ display: 'grid', gap: 8 }}>
                    {grouped[status].map(row => (
                      <div key={row.GuestId} className="card card-pad">
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                          <strong>{fullName(row)}</strong>
                          <div style={{ flex: 1 }} />
                          <span className={sideChipClass(row.Side)}>{row.Side}</span>
                        </div>
                        <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
                          📞 {row.MobileNumber || '—'} · {row.FunctionName || '—'}
                          {isAdmin && ` · by ${(row.AddedByName || row.InvitedByName || '').trim() || '—'}`}
                        </div>
                        {canEdit && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                            {mine(row)
                              ? INVITE_STATUSES.filter(s => s !== status).map(s => (
                                  <button key={s} className="btn light sm" onClick={() => mark(row, s)}>{s}</button>
                                ))
                              : <span className="muted" style={{ fontSize: 12 }}>shared by another member</span>}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
